import React, { useEffect } from "react";
import Footer from "../components/footer/Footer";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import WhyUs from "../components/whyus/WhyUs";
import BrandImages from "../components/brandImages/BrandImages";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import ContactSection from "../components/contactSection/ContactSection";
import tabData, { mainBannerImg, slidesData } from "../data/industryData";
import { useTranslation } from "react-i18next";
import IndustriesSection from "../components/newIndustriesSection";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";

const Industry = () => {
  const { t } = useTranslation("industries");
  const translatedTabData = t("tabData", { returnObjects: true });
  const whyUsData = t("sliderData", { returnObjects: true });
  const pionerSectionContent = t("pioneerChangeSectionData", {
    returnObjects: true,
  });
  const similerBannerDataEn = t("bannerContent", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("industyPageTitle", { returnObjects: false });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Our industry-specific IT solutions meet the unique challenges of your sector. We provide customized services that drive innovation & growth."
        />
      </Helmet>

      <MegaMenu />

      <div className="industry-banner mb-5">
        <SimilerBanner
          mainHeading={similerBannerDataEn.mainHeading}
          content={similerBannerDataEn.content}
          btnText2={similerBannerDataEn.btnText2}
          diffBannerBackgroundImage={mainBannerImg}
        />
      </div>
      <IndustriesSection />

      {/* 
      <PioneeringChange
        tabData={translatedTabData}
        mainHeading={pionerSectionContent?.mainHeading}
        greenHeading={pionerSectionContent?.greenHeading}
        content={pionerSectionContent?.sectionDescription}
      /> */}

      <DevelopingSolution heading="Powering Innovative Businesses With Top-Notch Services" />

      {/* <WhyUs
        slidesData={whyUsData?.industryPageSliderData}
        heading={whyUsData?.mainHeading}
        content={whyUsData?.sectionDescription}
      /> */}

      {/* <WhyChooseUs
        heading="for Software Development & Consulting Services?"
        greenHeading="Why Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
      /> */}

      {/* <BrandImages /> */}

      {/* <ContactSection heading="Get a free 30-minute consultancy worth $250" /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default Industry;
